// Import model
import { FilterFpRoomRequest } from '../models/FilterFpRoomRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { FpRoomCondition } from '../models/FpRoomCondition';
import { FpRoomFields } from '../models/FpRoomFields';
import { FpRoomIndexedFields } from '../models/FpRoomIndexedFields';

// Import dependency serializers (for complex types)
import { FpRoomConditionSerializer } from './FpRoomConditionSerializer';
import { FpRoomFieldsSerializer } from './FpRoomFieldsSerializer';
import { FpRoomIndexedFieldsSerializer } from './FpRoomIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterFpRoomRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterFpRoomRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterFpRoomRequest instance
   */
  static deserialize(json: string): FilterFpRoomRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterFpRoomRequest instance
   */
  static fromObject(obj: any): FilterFpRoomRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterFpRoomRequest');
    }


    const instance: FilterFpRoomRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as FpRoomIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as FpRoomFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        FpRoomConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterFpRoomRequest instances
   */
  static deserializeArray(json: string): FilterFpRoomRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterFpRoomRequest instance to a JSON string
   */
  static serialize(instance: FilterFpRoomRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterFpRoomRequest instance to a plain object
   */
  static toObject(instance: FilterFpRoomRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        FpRoomConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterFpRoomRequest instances to a JSON string
   */
  static serializeArray(instances: FilterFpRoomRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
